"use strict";

exports.__esModule = true;
exports.getTrackingIds = void 0;

var _createUuid = require("../../helpers/createUuid");

var _cookie = require("../../helpers/cookie");

/**
 * Create a new sessionId cookie
 * @todo add timestamp to cookie
 * @param {*} cookieName
 * @returns object with sessionid and viewsequence
 */
const newSessionId = cookieName => {
  const sessionId = (0, _createUuid.generateUuid)();
  (0, _cookie.setCookie)(cookieName, `${sessionId}.${1}`, 1 / 24 / 2, '/', getDomainName()); // cookie expires after 30'

  return {
    sessionid: sessionId,
    viewsequence: 1
  };
};
/**
 * Retrieve the sessionId from the querystring
 * @returns sessionid
 */


const getUtmValueFromQuerystring = querystringUtmKey => {
  const data = window.location.search;

  if (data) {
    const utmKey = querystringUtmKey;
    const utmParamIndex = data.indexOf(utmKey);

    if (utmParamIndex >= 0) {
      const index = data.substring(utmParamIndex + utmKey.length, data.length).indexOf('&');

      if (index < 0) {
        return data.substring(utmParamIndex + utmKey.length, data.length);
      } else {
        return data.substring(utmParamIndex + utmKey.length, data.length).substring(0, index);
      }
    }
  }

  return null;
};
/**
 * Gets the current sessionId and validates it. Replaces if necessary
 * When the sessionid is in the querystring > use this id (keep the session alive)
 *
 * @param {*} cookieName
 * @returns
 */


const setSessionId = cookieName => {
  // Check if there is already a session cookie
  const tokens = parseSessionCookie(cookieName);

  if (tokens) {
    // Check if there is a id in the querystring - use when available
    // 2 options:
    //    - there is a cookie _mhtc_sid & a value in the querystring: keep viewsequence, overwrite cookie value with value from querystring
    //    - there is no cookie _mhtc_sid & a value in the querystring: new viewsequence, with cookie value from querystring
    const viewsequence = tokens.viewsequence ?? 0;
    const sessionid = getUtmValueFromQuerystring('utm_prsid=') || tokens.sessionid; // Check if the sessionid is valid - create new cookie

    if ((sessionid == null ? void 0 : sessionid.length) === 36 && !isNaN(parseFloat(viewsequence))) {
      const newviewsequence = parseInt(viewsequence, 10) + 1;
      (0, _cookie.destroyCookie)(cookieName);
      (0, _cookie.setCookie)(cookieName, `${sessionid}.${newviewsequence}`, 1 / 24 / 2, '/', getDomainName()); // cookie expires after 30'

      return {
        sessionid: sessionid,
        viewsequence: newviewsequence
      };
    }

    return newSessionId(cookieName);
  }

  return newSessionId(cookieName);
};
/**
 * Parses the session cookie to separate the different components
 *
 */


const parseSessionCookie = (cookieName, onlySessionId = false) => {
  const cookieValue = (0, _cookie.getCookie)(cookieName); // TODO: add timestamp check

  if (cookieValue) {
    const tokens = cookieValue.split('.');
    return {
      sessionid: tokens[0],
      viewsequence: tokens[1]
    };
  }

  return {};
};
/**
 * Gets cookieId if available, sets it otherwise
 * Use querystring value if available
 *
 * @param {*} cookieName
 * @returns cookieId
 */


const setCookieId = cookieName => {
  // Check if the cookieId is available in the querystring
  const cid = getUtmValueFromQuerystring('utm_cid=');

  if (cid) {
    (0, _cookie.destroyCookie)(cookieName);
    (0, _cookie.setCookie)(cookieName, cid, 31, '/', getDomainName());
    return cid;
  }

  const cookieValue = (0, _cookie.getCookie)(cookieName);

  if (cookieValue) {
    return (0, _cookie.getCookie)(cookieName);
  }

  const cookieId = (0, _createUuid.generateUuid)();
  (0, _cookie.setCookie)(cookieName, cookieId, 31, '/', getDomainName());
  return cookieId;
};

function getDomainName() {
  var host = window.location.hostname;
  host = host.replace(/^[a-zA-Z-]*./i, "");
  return host;
}
/**
 * Sets a new viewId
 *
 * @param {*} cookieName
 * @returns
 */


const newViewId = cookieName => {
  const currentViewId = (0, _createUuid.generateUuid)();
  (0, _cookie.setCookie)(cookieName, currentViewId);
  return currentViewId;
};
/**
 * Gets the current view id (this is used when viewId is attached to events)
 *
 * @param {*} cookieName
 * @returns currentViewId
 */


const getCurrentId = cookieName => {
  const currentId = (0, _cookie.getCookie)(cookieName);
  return currentId;
};
/**
 * Returns the relevant trackingIds.
 * When the existing values flag is set to true the viewId is returned,
 * otherwise sessionId and cookieId are also included
 *
 * @param {boolean} [useExistingValues=false]
 * @returns
 */


const getTrackingIds = (useExistingValues = false) => {
  if (useExistingValues) {
    const viewid = getCurrentId('_mhtc_vId');
    const sessionid = parseSessionCookie('_mhtc_sId').sessionid || null;
    const cookieid = getCurrentId('_mhtc_cId');
    return {
      viewid,
      sessionid,
      cookieid
    };
  }

  return {
    viewid: newViewId('_mhtc_vId'),
    ...setSessionId('_mhtc_sId'),
    cookieid: setCookieId('_mhtc_cId')
  };
};

exports.getTrackingIds = getTrackingIds;